import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css'

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        localStorage.removeItem('isAuthenticated');
    }, [])

    const handleLogin = (e) => {
        e.preventDefault();
        if (username === 'target' && password === 'target@123') {
            localStorage.setItem('isAuthenticated', 'true'); // Set authentication flag
            setTimeout(() => {
                navigate('/dashboard');
            }, 1000);
        } else {
            alert('Invalid credentials');
        }
    };
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleLogin(e); // Trigger login when Enter is pressed
        }
    };
  
    

    return (
        <div className="login-box">
            <p>Login</p>
            <form >
                <div className="user-box">
                    <input
                        required
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        onKeyPress={handleKeyPress}
                    />
                    <label>User Id</label>
                </div>
                <div className="user-box">
                    <input
                        required
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        onKeyPress={handleKeyPress}
                    />
                    <label>Password</label>
                </div>
                <a href="#"  onClick={handleLogin}>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      Submit
    </a>
            </form>
           <p>
    Don&apos;t have an account? <a href="#" className="a2">Contact us!</a>
</p>

        </div>
    );
};

export default Login;
